function waitForPaint() {
  return new Promise<void>((resolve) => {
    requestAnimationFrame(() => requestAnimationFrame(() => resolve()));
  });
}

export async function printCertificateSheet(paper: HTMLElement | null) {
  if (!paper) return;

  const host = document.createElement("div");
  host.id = "certificate-print-host";
  const clone = paper.cloneNode(true) as HTMLElement;
  clone.removeAttribute("id");
  clone.classList.add("certificate-print-sheet");
  host.appendChild(clone);
  document.body.appendChild(host);
  document.documentElement.classList.add("is-certificate-printing");
  await waitForPaint();

  try {
    window.print();
  } finally {
    document.documentElement.classList.remove("is-certificate-printing");
    host.remove();
  }
}
